import type { ApplicantHeadData } from '~/domains/applicants/types'
import type { AcceptModalOrder } from '~/domains/orders/types'

export const acceptModalRef = {
  current: async (
    _order: AcceptModalOrder,
    _applicants: (ApplicantHeadData | number)[],
    _statusId: number
  ) => true
}

export const closeOrderModalRef = {
  current: () => {}
}

export const acceptModal = (
  order: AcceptModalOrder,
  applicants: (ApplicantHeadData | number)[],
  statusId: number
) => acceptModalRef.current(order, applicants, statusId)
